import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";
import { useRouter } from "src/hooks/useRouter";
import { localStrings } from "src/utils/localization";

interface IConfirmPolicyProps {
  confirmPolicy: boolean;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
}

// 통합 이용약관, 개인정보처리방침 동의
const ConfirmPolicy = ({
  confirmPolicy,
  handleChange,
}: IConfirmPolicyProps) => {
  const { openTermsService, openPrivatePolicy, openPaidTermsService } =
    useModal();
  const { t } = useTranslation();
  const { lang } = useRouter();
  return (
    <div className="form-item">
      <div className="flex flex-wrap">
        <input
          type="checkbox"
          name="confirmPolicy"
          id="confirmPolicy"
          checked={confirmPolicy}
          onChange={handleChange}
          // htmlFor="confirmPolicy"
        />
        <label className="inputArea-label" htmlFor="confirmPolicy"></label>
        <label
          className={`form-input-label ${lang === "ko" ? "" : "mg ml-24"}`}
        >
          {t("siteType.agreement1")}
          <a onClick={openTermsService}>
            <b className="text text--black">{t("siteType.agreement2")}</b>
          </a>
          {t("siteType.agreement3")}
          <a onClick={openPrivatePolicy}>
            <b className="text text--black">{t("siteType.agreement4")}</b>
          </a>
          {/* <a> */}
          {/* 유료 이용약관 */}
          {/* {window.sessionStorage.getItem("product") === "WRAPSODY_ECO" && (
            <>
              {t("siteType.agreement5")}
              <a onClick={openPaidTermsService}>
                <b className="text text--black">
                  {t("siteType.agreement6")}
                </b>
              </a>
            </>
          )} */}
          {t("siteType.agreement7")}
        </label>
      </div>
      <div className="mg mt-20 form-item-delete">{t("siteType.info")}</div>
    </div>
  );
};

export default ConfirmPolicy;
